import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../../common/store/generic.effects';
import {
  WorkScheduleAction,
  workScheduleActions,
} from './work-schedule.actions';
import { WorkScheduleApiService } from './work-schedule.api.service';

@Injectable()
export class WorkScheduleEffects {
  constructor(
    private readonly workScheduleApiService: WorkScheduleApiService,
    private readonly action$: Actions<WorkScheduleAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    workScheduleActions.getById,
    this.workScheduleApiService.getById,
  );

  createInstance = createApiCallEffects(
    this,
    this.action$,
    workScheduleActions.createInstance,
    this.workScheduleApiService.createInstance,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    workScheduleActions.add,
    this.workScheduleApiService.add,
  );

  update = createApiCallEffects(
    this,
    this.action$,
    workScheduleActions.update,
    this.workScheduleApiService.update,
  );

  delete = createApiCallEffects(
    this,
    this.action$,
    workScheduleActions.delete,
    this.workScheduleApiService.delete,
  );
}
